const accents = require("remove-accents");

const addSEOSupportToURL = url =>
	url
		.split("/")
		.map(segment => {
			let processedSegment = segment;
			processedSegment = accents.remove(processedSegment);
			processedSegment = processedSegment.replace(/^\s+|\s+$/g, ""); // Trim leading/trailing spaces
			processedSegment = processedSegment.replace(/[-,;_=\s]+/g, "-"); // Convert spaces to hyphens
			processedSegment = processedSegment.replace(/[^-\w\s]/g, ""); // Remove unneeded characters
			processedSegment = processedSegment.toLowerCase(); // Convert to lowercase

			return processedSegment;
		})
		.join("/");

const getHotelURLRaw = (lang, country, destination, hotel) =>
	`/${lang}/hotels${country && `/${country}`}${destination && `/${destination}`}/${hotel}`;

const getHotelURL = (lang, country, destination, hotel) =>
	addSEOSupportToURL(getHotelURLRaw(lang, country, destination, hotel));

// Create contact-us slug dynamically
const getSlugByLocale = (pageData, locale) => {
	const lang = locale.slice(0, 2);
	const filterPage = pageData.edges.find(edge => edge.node.node_locale === locale);
	return `/${lang}/${filterPage.node.slug}`;
};

module.exports = {
	addSEOSupportToURL,
	getHotelURLRaw,

	getHotelURL,
	getSlugByLocale,
};
